import { render, staticRenderFns } from "./feedbackPage.vue?vue&type=template&id=280e0c1c&scoped=true"
import script from "./feedbackPage.vue?vue&type=script&lang=js"
export * from "./feedbackPage.vue?vue&type=script&lang=js"
import style0 from "./feedbackPage.vue?vue&type=style&index=0&id=280e0c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e0c1c",
  null
  
)

export default component.exports